import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import AdminSidebar from "@/components/AdminSidebar";
import { AdminLayoutProvider, AdminLayoutContext } from "@/contexts/AdminLayoutContext";

const AdminPageContent = () => {
  const { isSidebarOpen, toggleSidebar } = useContext(AdminLayoutContext);

  return (
    <div className="flex flex-grow">
      {isSidebarOpen ? (
        <AdminSidebar />
      ) : (
        <div
          className="w-16 border-r border-gray-200 dark:border-slate-700 flex items-start justify-center pt-4 cursor-pointer hover:bg-muted transition-colors"
          onClick={toggleSidebar}
        >
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => e.stopPropagation()}
            aria-label="Menü megnyitása"
          >
            <Menu size={20} />
          </Button>
        </div>
      )}
      <main className="flex-grow p-8">
        <Outlet />
      </main>
    </div>
  );
};

const AdminPage = () => {
  return (
    <AdminLayoutProvider>
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <AdminPageContent />
      </div>
    </AdminLayoutProvider>
  );
};

export default AdminPage;